import React, {useMemo} from "react";
import {IM24CompositionCard} from "../../models/generated/cms.interface";
import {Media, MontanaMediaRatios} from "@montana/shared/media/media.component";
import {Link} from "@montana/shared/link/link.component";
import './composition-card.styles.scss';
import {SeriesLink} from "@montana/shared/series-link/series-link.component";
import {useTranslations} from "@montana/containers/translations";
import {formatString} from "@montana/helpers/string-format/string-format.helper";

export function CompositionCard(props: IM24CompositionCard) {
    const {
        title,
        image,
        link,
        colors,
        tagLink
    } = props;

    const translate = useTranslations();

    const colorDescription = useMemo(() => {
        if (!colors || colors.length === 0) {
            return title;
        }

        const colorLinks = colors.slice(0, 4).map((color) => `<a href="${color.link?.url}">${color.colorName}</a>`);

        if (colorLinks.length === 1) {
            const translation = translate((t) => t.compositionCarousel.singleColorComposition, '**{0} translation for {1}**');
            return formatString(translation, title ?? '', colorLinks[0]);
        }

        const translation = translate((t) => t.compositionCarousel.colorsInComposition, '** {0} translation for {1} and {2} **');

        const lastColor = colorLinks.pop();
        const firstColors = colorLinks.map((colorLink) => colorLink.replace('</a>', ',</a>')).join(' ');

        return formatString(translation, title ?? '', firstColors, lastColor ?? '');
    }, [colors, title, translate]);

    return (
        <div className="composition-card">
            <div className="composition-card__media-wrapper">
                <Link to={link?.url} className="composition-card__link">
                    <Media
                        image={image}
                        mediaRatio={MontanaMediaRatios.Portrait}
                        placeholder
                    />
                </Link>
            </div>
            <div className="composition-card__content">
                <div className="composition-card__header">
                    {tagLink?.url && tagLink.name ? <SeriesLink link={tagLink} title={`${translate(t => t.compositionCarousel.series, 'Series:')} ${tagLink.name}`}/> : <div></div>}
                </div>
                {colorDescription && <div className="composition-card__description"
                                          dangerouslySetInnerHTML={{__html: colorDescription}}></div>}
            </div>
        </div>
    );
}
